module.exports = __webpack_public_path__ + "media/images/slider-text-bg@2x-b695ff6246babdbcc348d19920f4600f.png";